<template>
  <div class="project-side-nav-section">

    <div class="team-li" style="margin-top: 16px;">
      <div class="side-title-section">
        <div class="side-title">
          <i class="fas fa-star"></i> Favorites
        </div>
        <div class="side-icon">
          <i class="fas fa-caret-right"></i>
        </div>
      </div>
    </div>

    <div class="team-li" style="margin-top: 45px;">
      <div class="side-title-section">
        <div class="side-title">
          Teams
        </div>
        <div class="side-icon">
          <i class="fas fa-caret-right" v-show='!teamActive' @click="teamActive=!teamActive"></i>
          <i class="fas fa-caret-down" v-show='teamActive' @click="teamActive=!teamActive"></i>
        </div>
      </div>

      <div class="team-list" v-show='teamActive'>

        <div class="team-li" v-if='ownerTeams' v-for="team in ownerTeams" @click="updateCurrentUserTeam(team.id)">
          <div class="team-li-icon" :style="{'background': randColor()}">
          </div>
          <div class="team-li-title">
            {{team.name}}
          </div>
        </div>

        <div class="team-li" v-if='memberTeams' v-for="team in memberTeams" @click="updateCurrentUserTeam(team.id)">
          <div class="team-li-icon" :style="{'background': randColor()}">
          </div>
          <div class="team-li-title">
            {{team.name}}
          </div>
        </div>
      </div>
    </div>

    <div class="team-li" style="margin-top: 45px;">
      <div class="side-title-section">
        <div class="side-title">
          Personal Projects
        </div>
        <div class="side-icon">
          <i class="fas fa-caret-right" v-show='!ppActive' @click="ppActive=!ppActive"></i>
          <i class="fas fa-caret-down" v-show='ppActive' @click="ppActive=!ppActive"></i>
        </div>
      </div>

      <div class="team-list" v-show='ppActive'>

        <div class="team-li" v-if='personalProjects' v-for="project in personalProjects" @click="goToProject(project.id)">
          <div class="team-li-icon" style="background: #3A414F;">
          </div>
          <div class="team-li-title">
            {{project.title}}
          </div>
        </div>

      </div>
    </div>

    <div class="team-li" style="margin-top: 45px;">
      <div class="side-title-section">
        <div class="side-title">
          My Templates
        </div>
        <div class="side-icon">
          <i class="fas fa-caret-right"></i>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import api from '@/api'

export default {
  name: 'Projects-side-nav',
  components: {

  },

  data () {
  	return {
      ownerTeams: null,
      memberTeams: null,
      teamActive: true,
      ppActive: true,
      personalProjects: null,
      colors: ['#f4a261', '#2a9d8f', '#e76f51', '#264653', '#e9c46a'],
      color: '#f4a261',
  	}
  },

  methods: {
    async findUserTeams() {
      const response = await api.users.findUserTeams()
      if (response.status < 300) {
        console.log('user teams', response)
        this.ownerTeams = response.data.owner
        this.memberTeams = response.data.member
      } else {
        if (response.status == 401) {
          this.findUserTeams()
        }
        console.log('Error loading projects', response)
      }
    },

    async updateCurrentUserTeam (teamId) {
      const response = await api.users.updateCurrentUserTeam(teamId)
      if (response.status < 300) {
        this.$store.commit('inctementChangeTeamState')
        console.log('team!', response.data)
      } else {
        console.log('Error loading projects', response)
      }
    },

    async getPersonalProjects () {
      const response = await api.users.getPersonalProjects()
      if (response.status < 300) {
        console.log('personal!', response.data)
        this.personalProjects = response.data
      } else {
        if (response.status == 401) {
          this.getPersonalProjects()
        }
        console.log('Error loading projects', response)
      }
    },

    goToProject (id) {
      this.$router.push('/'+id+'/dashboard')
    },

    randColor () {
      return this.colors[Math.floor(Math.random() * this.colors.length)]
    },
  },

  mounted () {
    this.findUserTeams()
    this.getPersonalProjects()
  }
}
</script>

<style lang="scss" scoped>

  .project-side-nav-section {

    .side-title-section {
      padding-bottom: 0;
      overflow: auto;
      border-bottom: 1px solid #dedede;

      .side-title {
        float: left;
        margin-top: -5px;
        font-size: 20px;
        font-weight: 600;
        color: #3A414F;
      }

      .side-icon {
        float: right;
        font-size: 18px;
        cursor: pointer;
        transition: all 0.25s;

        &:hover {
          opacity: 0.7;
        }
      }
    }

    .team-list {

      .team-li {
        position: relative;
        margin-top: 15px;
        margin-bottom: 15px;
        overflow: auto;
        cursor: pointer;
        transition: all 0.25s;

        &:hover {
          opacity: 0.7;
        }

        .team-li-icon {
          float: left;
          width: 15px;
          height: 15px;
          margin-left: 5px;
          border-radius: 4px;
          background: red;
        }

        .team-li-title {
          float: left;
          margin-left: 10px;
          font-size: 16px;
          font-weight: 500;
          text-transform: capitalize;
          line-height: 18px;
        }
      }
    }

    .item-title {
      border-bottom: 1px solid #dedede;
    }

    .item-li {

    }
  }

</style>
